/**
 * Конвертация координат и работа с границами карты.
 *
 * У нас (БД, API, пропсы компонентов) координаты идут как [широта, долгота],
 * а Яндекс.Карты JS API 3.0 принимает [долгота, широта]. Это единственное место,
 * где живёт разница — компоненты никогда не переставляют координаты сами.
 */

export const BISHKEK_LATLNG = [42.8746, 74.5698];
export const BISHKEK_LNGLAT = [74.5698, 42.8746];

/** [lat, lng] -> [lng, lat] для ymaps3 */
export function toLngLat(latitude, longitude) {
  return [Number(longitude), Number(latitude)];
}

/** [lng, lat] от ymaps3 -> { lat, lng } */
export function fromLngLat(coords) {
  return { lat: coords[1], lng: coords[0] };
}

/**
 * Есть ли валидные координаты. Именно `Number.isFinite`, а не проверка на falsy:
 * широта или долгота ровно 0 — валидное значение.
 */
export function hasCoords(latitude, longitude) {
  return Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude));
}

/**
 * Границы, покрывающие все точки, в формате ymaps3 LngLatBounds.
 *
 * `map.setLocation({ bounds })` не умеет padding (в отличие от leaflet fitBounds),
 * поэтому расширяем прямоугольник на долю его размера, чтобы маркеры не липли к краям.
 *
 * @param {Array<{latitude:number, longitude:number}>} points
 * @param {number} paddingRatio доля расширения по каждой оси
 * @returns {[[number,number],[number,number]]|null} [[minLng,minLat],[maxLng,maxLat]]
 */
export function boundsFromLatLngList(points, paddingRatio = 0.12) {
  const valid = points.filter((p) => hasCoords(p.latitude, p.longitude));
  if (valid.length === 0) return null;

  const lats = valid.map((p) => Number(p.latitude));
  const lngs = valid.map((p) => Number(p.longitude));

  const minLat = Math.min(...lats);
  const maxLat = Math.max(...lats);
  const minLng = Math.min(...lngs);
  const maxLng = Math.max(...lngs);

  // Минимальный отступ, чтобы одна точка не давала вырожденный прямоугольник.
  const padLat = Math.max((maxLat - minLat) * paddingRatio, 0.002);
  const padLng = Math.max((maxLng - minLng) * paddingRatio, 0.002);

  return [
    [minLng - padLng, minLat - padLat],
    [maxLng + padLng, maxLat + padLat],
  ];
}
